var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"event-btn",class:{ [`${_vm.type}-btn`]: true, [`${_vm.type}-btn__loading`]: _vm.loading }},_vm.$listeners),[_vm._t("default"),(_vm.loading)?_c('loader'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }